// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter, getIdentifierConstraint, getRelatedTypeConstraint } from '../../../_abstract/adapter';
import { RelatedType } from '../../../../services';
import { ModuleDriver } from '../../../_contracts';
import { getModuleBase } from '../../../_helpers/adapter';
import { EmbedVersion } from '../../Embed.contracts';
export class EmbedVideoAdapter extends AbstractAdapter {
    objectToToken(object) {
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            video: {
                presence: true,
                type: 'object'
            },
            'video.type': getRelatedTypeConstraint(RelatedType.File, true),
            'video.value': getIdentifierConstraint(true)
        });
        if (typeof content.thumbnail !== 'undefined') {
            this.validate(content.thumbnail, {
                type: getRelatedTypeConstraint(RelatedType.File),
                value: getIdentifierConstraint()
            });
        }
        const { description, thumbnail, video } = content;
        if (!video) {
            throw new Error('[video.value] is required, but none was provided');
        }
        let meta = {};
        let raw = `#VIDEO[ id: ${video.value} ]`;
        if (typeof description === 'string' && description.length > 0) {
            meta = {
                ...meta,
                description
            };
            raw = raw.substring(0, raw.length - 1) + `| description: ${description} ]`;
        }
        if (typeof thumbnail !== 'undefined' && typeof thumbnail.value === 'number') {
            const thumbnailId = thumbnail.value;
            if (typeof thumbnailId === 'number') {
                meta = {
                    ...meta,
                    thumbnailId
                };
                raw = raw.substring(0, raw.length - 1) + `| thumbnailId: ${thumbnailId} ]`;
            }
        }
        return {
            content: String(video.value),
            raw,
            meta,
            type: TokenType.EmbedVideo
        };
    }
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                description: {
                    type: 'string'
                },
                thumbnailId: {
                    type: 'number'
                }
            });
        }
        const { content, meta } = token;
        const object = {
            ...getModuleBase(),
            content: {},
            driver: ModuleDriver.Embed,
            version: EmbedVersion.Video
        };
        if (typeof content === 'string') {
            object.content.video = {
                type: RelatedType.File,
                value: Number(content)
            };
        }
        if (typeof meta !== 'undefined') {
            const { description, thumbnailId } = meta;
            if (typeof description === 'string') {
                object.content.description = description;
            }
            if (typeof thumbnailId === 'number') {
                object.content.thumbnail = {
                    type: RelatedType.File,
                    value: thumbnailId
                };
            }
        }
        object.content.type = EmbedVersion.Video;
        return object;
    }
}
